module.exports = __webpack_public_path__ + "img/icon-cart.18467bdf.svg";